import { FailedDocumentsResponse } from '../../types/pipelineData';

export const publishVirtualAssistant = async (virtual_assistant_id: string) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/${virtual_assistant_id}/publish`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  
    return await response.json();
};

export const unpublishVirtualAssistant = async (virtual_assistant_id: string) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/${virtual_assistant_id}/unpublish`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  
    return await response.json();
};
export const deleteVirtualAssistant = async (virtual_assistant_id: string) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/${virtual_assistant_id}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  
    return await response.json();
};

export const cloneVirtualAssistant = async (virtual_assistant_id: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/${virtual_assistant_id}/clone`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return await response.json();
};

export const getAssistantById = async (virtual_assistant_id: string, net_id?: string) => {
    const url = net_id
        ? `${process.env.REACT_APP_API_URL}/api/virtual-builders/${virtual_assistant_id}?net_id=${encodeURIComponent(net_id)}`
        : `${process.env.REACT_APP_API_URL}/api/virtual-builders/${virtual_assistant_id}`;

    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (response.status === 403) {
        const error = new Error('You do not have permission to access this Virtual Assistant');
        (error as any).status = 403;
        throw error;
    }

    if (response.status === 404) {
        const error = new Error('Virtual Assistant not found');
        (error as any).status = 404;
        throw error;
    }

    if (!response.ok) {
        const error = new Error('Failed to fetch Virtual Assistant');
        (error as any).status = response.status;
        throw error;
    }

    return await response.json();
};

export const updateAssistant = async (virtual_assistant_id: string, virtual_assistant: object) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/${virtual_assistant_id}`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(virtual_assistant), 
    });

  return await response.json();
};
export const saveAssistant = async (virtual_assistant_id: string, virtual_assistant: object) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(virtual_assistant), 
  });

return await response.json();
};

export const uploadFile = async (file: File, type: string, virtual_assistant_id: string, netId: string): Promise<{ fileName: string, fileLocation: string }> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);
  
  // If virtual_assistant_id is empty, set it as "emp"
  formData.append('virtual_assistant_id', virtual_assistant_id || "temp");
  
  formData.append('netId', netId);
  
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/upload-file`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });
    
    if (!response.ok) {
      throw new Error(`Upload failed: ${response.statusText}`);
    }
    
    const data: any = await response.json();
    return { fileName: data.file_name, fileLocation: data.file_location };
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }
};

export const uploadCustomFile = async (file: File, type: string, virtual_assistant_id: string, netId: string): Promise<{ fileName: string, fileLocation: string, file_unique_id: string }> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);
  formData.append('virtual_assistant_id', virtual_assistant_id);
  formData.append('netId', netId);

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/upload-custom-file`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.statusText}`);
    }

    const data: any = await response.json();
    return { fileName: data.file_name, fileLocation: data.file_location, file_unique_id: data.file_unique_id };
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }
};

export const downloadFile = async (virtual_assistant_id: string, file_unique_id: string): Promise<Blob> => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/download-file/${virtual_assistant_id}/${file_unique_id}`, {
      method: 'GET',
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Download failed: ${response.status} ${response.statusText}`);
    }

    return await response.blob();
  } catch (error) {
    console.error('Download error:', error);
    throw error;
  }
};

export const importVirtualAssistant = async (netId: string,owner_name: string,file: File): Promise<any> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('netId', netId);
  formData.append('owner_name', owner_name);

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/import`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Import failed: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Import error:', error);
    throw error;
  }
};

export const exportVirtualAssistant = async (virtual_assistant_id: string): Promise<Blob> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/export/${virtual_assistant_id}`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`Export failed: ${response.statusText}`);
  }

  return await response.blob();
};

export const mergeVirtualAssistant = async (sourceAssistantId: string, targetAssistantId: string, deleteAfterMerge: boolean) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/${sourceAssistantId}/merge`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ 'target_assistant_id': targetAssistantId, 'delete_after_merge': deleteAfterMerge }),
  });

  if (!response.ok) {
    throw new Error(`Merge failed: ${response.statusText}`);
  }

  return await response.json();
};

interface PageResponse<T> {
  assistants: T[];
  continuationToken: string | null;
  totalPages: number;
  inference_url: string |  '';
  published_count: number;
 }
 
 interface Assistant {
  app_id: string;
  app_name: string;
  app_owner: string;
  app_publishstatus: string;
  app_url: string;
  last_modified: string;
  app_description: string;
  id: string | null;
  app_ai_face: string | null;
  co_owner: any | null;
  owner_name: string | null;
 }

 export const fetchAssistants = async (
  netId: string, 
  pageSize: number = 10,
  skip: number = 0,
  searchTerm: string = ''
 ): Promise<PageResponse<Assistant>> => {
  return fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/get_by_net_id_paginated/${netId}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      pageSize,
      skip,
      searchTerm
    })
  }).then(res => res.json());
};

export const fetchSharedAssistants = async (
  netId: string, 
  pageSize: number = 10,
  skip: number = 0,
  searchTerm: string = ''
 ): Promise<PageResponse<Assistant>> => {
  return fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/get_shared_va_paginated/${netId}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      pageSize,
      skip,
      searchTerm
    })
  }).then(res => res.json());
};

export const generateTokenAPI = async (dummyUser: string, code: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/bypasstoken`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      dummy_user:dummyUser ,
      code: code
    })
  });

  return await response.json();
};

export const validateFileHeaders = async (file: File): Promise<{ message: string, status: string, expected_headers: string, received_headers: string }> => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/validate_calendar_headers`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Validation Failed: ${response.statusText}`);
    }

    const data: any = await response.json();
    return data;
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }
};

export const triggerPiepeline = async (virtual_assistant_id: string, run_type: string, queue_type: string,full_load_value: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getdata/triggerpiepeline`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 'app_id': virtual_assistant_id, 'run_type': run_type, 'queue_type': queue_type, 'is_incremental':full_load_value }),
  });

return await response.json();
};

export const fetchSystemPrompt = async (virtual_assistant_id: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/common/system_prompt`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 'app_id': virtual_assistant_id, 'net_id': '' }),
  });

return await response.json();
};

export const fetchWebScrape = async (start_url: string, max_depth: number, blocked_patterns: string, include_external_links: boolean, restrict_to_start_path: boolean, app_id: string, webid?: string | null ) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/common/web_scrape`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ start_url, max_depth, blocked_patterns, app_id, webid, include_external_links, restrict_to_start_path }),
  });

   return await response.json();
};

export const fetchWebsiteDocumentCache = async (webid: string ) => {
   const response = await fetch(`${process.env.REACT_APP_API_URL}/api/document/${webid}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    });
   const json = await response.json();

  if (!response.ok) {
    const error = new Error(json.detail || 'Unknown error');
    (error as any).status = response.status;
    (error as any).detail = json.detail;
    throw error;
  }

  return json;
};

export const deleteChat = async (id: string) => {
  const response = '';
  // const response = await fetch(`${process.env.REACT_APP_API_URL}/api/common/web_scrape`, {
  //     method: 'POST',
  //     credentials: 'include',
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify({ start_url,max_depth,blocked_patterns}),
  // });

  return await response;
};

export const PipelineRun = async (pipeline_name: string, app_id: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pipelines/runs`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pipeline_name,app_id }),

  });
  return await response.json();
};

export const FailedDocuments = async (
  pipeline_run_id: string,
  app_id: string
): Promise<FailedDocumentsResponse> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pipelines/failed-documents`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pipeline_run_id,app_id }),

  });
  if (!response.ok) {
    throw new Error(`Failed to load failed documents: ${response.status} ${response.statusText}`);
  }
  return await response.json();
};

export const updateCoOwner = async (assistantId: string, selectedUser: any) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/updatecoowner`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ app_id:assistantId,co_owner:selectedUser }),

  });
  return await response.json();
};

export const getByNetId = async (net_id: string) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/virtual-builders/get_by_net_id/${net_id}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return await response.json();
};

// Add these functions to your existing API file

export const cancelWebScrape = async (document_id: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/common/web_scrape/${document_id}/cancel`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to cancel web scraping');
  }

  return await response.json();
};

export const cancelWebScrapePost = async (document_id: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/common/web_scrape/cancel`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ document_id }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to cancel web scraping');
  }

  return await response.json();
};

export const getWebScrapeStatus = async () => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/common/web_scrape/status`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to get web scrape status');
  }

  return await response.json();
};

export const getActiveWebScrapes = async () => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/common/web_scrape/active`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to get active web scrapes');
  }

  return await response.json();
};

export const cancelPipeline = async (pipelineName: string, appId: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pipelines/cancel`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        pipeline_name: pipelineName,
        app_id: appId
      }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || error.message || 'Failed to cancel pipeline');
  }

  return await response.json();
};